(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
class ProductGallery {
  constructor(container) {
    this.container = container;
    this.slidesContainer = container.querySelector('.gallery-slides');
    this.slides = this.slidesContainer.querySelectorAll('.gallery-cell');
    this.currentIndex = 0;
    this.dotsContainer = container.querySelector('.gallery-dots');
    this.prevButton = container.querySelector('.gallery-prev');
    this.nextButton = container.querySelector('.gallery-next');
    this.touchStartX = null;
    this.touchEndX = null;
    this.isMobile = window.innerWidth < 768;
    this.isSwipingGallery = false;

    if (this.slides.length > 1) {
      this.init();
    }
  }

  init() {
    this.createDots();
    this.bindEvents();
    this.showSlide(0);
  }

createDots() {
  if (!this.dotsContainer) return;
  
  // Get existing dots
  this.dots = Array.from(this.dotsContainer.querySelectorAll('.gallery-dot'));
  
  // Add click handlers to existing dots
  this.dots.forEach(dot => {
    const index = parseInt(dot.dataset.index, 10);
    dot.addEventListener('click', () => this.showSlide(index));
  });
}
  bindEvents() {
    // Bind arrow events
    if (this.prevButton) {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.prevSlide();
      });
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextSlide();
      });
    }

    // Bind touch events
    this.bindTouchEvents();

    // Handle window resize
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 768;
    });
  }

  bindTouchEvents() {
    this.container.addEventListener('touchstart', (e) => {
      this.touchStartX = e.touches[0].clientX;
      this.isSwipingGallery = true;
      
      // Prevent parent carousel scroll
      const carousel = this.container.closest('.products-slider');
      if (carousel) {
        carousel.style.overflow = 'hidden';
      }
    }, { passive: true });

    this.container.addEventListener('touchmove', (e) => {
      if (!this.isSwipingGallery) return;
      this.touchEndX = e.touches[0].clientX;
      
      // Calculate movement
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) > 5) {
        e.preventDefault();
      }
    }, { passive: false });

    this.container.addEventListener('touchend', () => {
      if (this.isSwipingGallery && this.touchStartX !== null && this.touchEndX !== null) {
        const diff = this.touchStartX - this.touchEndX;
        if (Math.abs(diff) > 30) {
          if (diff > 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
        }
      }
      
      // Reset touch tracking
      this.touchStartX = null;
      this.touchEndX = null;
      this.isSwipingGallery = false;
      
      // Re-enable parent carousel scroll
      const carousel = this.container.closest('.products-slider');
      if (carousel) {
        carousel.style.overflow = 'auto';
      }
    });
  }

// Update the showSlide method in your JavaScript
showSlide(index) {
  // Update slides
  this.slides.forEach((slide, i) => {
    if (i === index) {
      slide.classList.add('is-selected');
    } else {
      slide.classList.remove('is-selected');
    }
  });

  // Update dots
  const dots = this.dotsContainer.querySelectorAll('.gallery-dot');
  dots.forEach((dot, i) => {
    if (i === index) {
      dot.classList.add('is-selected');
    } else {
      dot.classList.remove('is-selected');
    }
  });

  this.currentIndex = index;
}

  nextSlide() {
    const newIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(newIndex);
  }

  prevSlide() {
    const newIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.showSlide(newIndex);
  }
}

// Initialize galleries
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    new ProductGallery(gallery);
  });
});

// Handle Shopify section events
document.addEventListener('shopify:section:load', (event) => {
  const galleries = event.target.querySelectorAll('[data-product-gallery]');
  galleries.forEach(gallery => {
    new ProductGallery(gallery);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
